module.exports = __webpack_public_path__ + "img/green_check.f97565ba.svg";